import PropTypes from "prop-types"
import React, { useEffect, useRef } from "react"
// //Import Scrollbar
import SimpleBar from "simplebar-react"
// MetisMenu
import MetisMenu from "metismenujs"
import { withRouter, Link } from "react-router-dom"
//i18n
import { withTranslation } from "react-i18next"
// import { useSelector } from 'react-redux'

const SurveyUserSidebarContent = props => {
  const ref = useRef()
  // const history = useHistory()

  // const { leftMenu, userDetail } = useSelector(state => ({
  //   leftMenu: state.Layout.leftMenu,
  //   userDetail: state.Users.userDetail,
  // }))

  // Use ComponentDidMount and ComponentDidUpdate method symultaniously
  useEffect(() => {
    const pathName = props.location.pathname

    const initMenu = () => {
      new MetisMenu("#side-menu")
      let matchingMenuItem = null
      const ul = document.getElementById("side-menu")
      const items = ul.getElementsByTagName("a")
      for (let i = 0; i < items.length; ++i) {
        if (pathName === items[i].pathname) {
          matchingMenuItem = items[i]
          break
        }
      }
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem)
      }
    }
    initMenu()
  }, [props.location.pathname])

  useEffect(() => {
    ref.current.recalculate()
  })

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300
      }
    }
  }

  function activateParentDropdown(item) {
    item.classList.add("active")
    const parent = item.parentElement
    const parent2El = parent.childNodes[1]
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show")
    }

    if (parent) {
      parent.classList.add("mm-active")
      const parent2 = parent.parentElement

      if (parent2) {
        parent2.classList.add("mm-show") // ul tag

        const parent3 = parent2.parentElement // li tag

        if (parent3) {
          parent3.classList.add("mm-active") // li
          parent3.childNodes[0].classList.add("mm-active") //a
          const parent4 = parent3.parentElement // ul
          if (parent4) {
            parent4.classList.add("mm-show") // ul
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.add("mm-show") // li
              parent5.childNodes[0].classList.add("mm-active") // a tag
            }
          }
        }
      }
      scrollElement(item)
      return false
    }
    scrollElement(item)
    return false
  }

  // const [selectedTag, setSelectedTag] = useState('')

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu" className="mt-4">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li>
              <Link to="/dashboard" className="">
                <i className="bx bxs-dashboard"></i>
                <span>{props.t("Dashboard")}</span>
              </Link>
            </li>
            {/* 
            <li className="menu-title mt-3">{props.t("Data")} </li> */}

            <li>
              <Link to="/#" className="has-arrow">
                <i className="bx bx-home"></i>
                <span>{props.t("Families")}</span>
              </Link>
              <ul className="sub-menu" aria-expanded="false">
                <li>
                  <Link to="/families">{props.t("All Families")}</Link>
                </li>
                <li>
                  <Link to="/family/create">{props.t("Create Family")}</Link>
                </li>
              </ul>
            </li>

            <li>
              <Link to="/familymembers">
                <i className="bx bx-group"></i>
                <span>{props.t("Members")}</span>
              </Link>
              {/* <ul className="sub-menu" aria-expanded="false">
                <li>
                  <Link to="/familymembers">{props.t("All Members")}</Link>
                </li>
                <li>
                  <Link to="/familymember/create">
                    {props.t("Create Member")}
                  </Link>
                </li>
              </ul> */}
            </li>
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  )
}

SurveyUserSidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(SurveyUserSidebarContent))
